/* eslint-disable no-prototype-builtins */

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import IconButton from '@mui/material/IconButton'
import Button from '@mui/material/Button'
import Modal from '@mui/material/Modal'

import ReviewerItemCard from '../items/ReviewerItemCard'

import { navbarHeight, footerHeight, positionChangeWidthSm } from '../../../../helpers/variableDefaults'
import { newFriendReviewerTextField } from '../../../../helpers/textfields'
import { advisoryTypography } from '../../../../helpers/typographies'
import { standardButton, deleteFriendIconButton } from '../../../../helpers/buttons'
import { noDuplicatesInArray, dummyBoxWidth } from '../../../../helpers/globalHelpers'

export const selectReviewerListJSX = (isDemo, reviewerProfiles, selectedReviewType, setSelectedReviewerProfile, setReviewerProfileToView, setOpenFullReviewerProfileModal, stripePaymentForm, setStripePaymentForm, width) => {
  return (
    <Box
      sx={{
        mt: 2, mb: 6,
        pt: 2, pb: 4,
        backgroundColor: 'whitesmoke',
        boxShadow: 3,
        borderRadius: '5px',
        width: '95%',
        // maxWidth: '600px',
        display: 'flex', flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center',
        flexWrap: 'wrap',
      }}
    >
      {/* Title and Advisory */}
      <Box
        sx={{
          mb: 2,
          width: '100%',
          display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
        }}
      >
        <Typography
          sx={{
            fontWeight: 'bold',
            fontSize: '20px',
          }}
        >
          {selectedReviewType.type === 'AI' ? `Select an AI Assistant` : `Select an Expert`}
        </Typography>

      </Box>

      {/* List of Reviewers */}
      <Box
        sx={{
          width: '95%',
          display: 'flex', flexDirection: 'row', justifyContent: reviewerProfiles.filter((reviewerProfileFilterItem => selectedReviewType.type === 'AI' ? reviewerProfileFilterItem.isAIReviewer : !reviewerProfileFilterItem.isAIReviewer )).length >= 3 ? 'space-around' : 'center', alignItems: 'center',
          flexWrap: 'wrap',
        }}
      >

        {/* List of Reviewers */}
        {reviewerProfiles.filter((reviewerProfileFilterItem => selectedReviewType.type === 'AI' ? reviewerProfileFilterItem.isAIReviewer : !reviewerProfileFilterItem.isAIReviewer )).map((reviewerProfileItem, reviewerProfileItemIndex) => (
          <Box
            key={reviewerProfileItemIndex}
            sx={{
              my: 1, mx: reviewerProfiles.filter((reviewerProfileFilterItem => selectedReviewType.type === 'AI' ? reviewerProfileFilterItem.isAIReviewer : !reviewerProfileFilterItem.isAIReviewer )).length >= 3 ? 0 : 2,
              py: 1, px: 1,
              width: '250px',
              maxWidth: '250px',
              backgroundColor: reviewerProfileItem.isFeatured ? 'mistyrose' : reviewerProfileItem.isCoach ? 'lightyellow' : 'white',
              border: 2,
              borderColor: 'black',
              borderRadius: '5px',
              display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
            }}
          >

            <ReviewerItemCard reviewerProfileItem={reviewerProfileItem} reviewerProfileItemIndex={reviewerProfileItemIndex} setSelectedReviewerProfile={setSelectedReviewerProfile} setReviewerProfileToView={setReviewerProfileToView} setOpenFullReviewerProfileModal={setOpenFullReviewerProfileModal} stripePaymentForm={stripePaymentForm} setStripePaymentForm={setStripePaymentForm} isDemo={isDemo} />

          </Box>
        ))}


        {/* Dummy Boxes */}
        {reviewerProfiles.filter((reviewerProfileFilterItem => selectedReviewType.type === 'AI' ? reviewerProfileFilterItem.isAIReviewer : !reviewerProfileFilterItem.isAIReviewer )).length > 3 && reviewerProfiles.filter((reviewerProfileFilterItem => selectedReviewType.type === 'AI' ? reviewerProfileFilterItem.isAIReviewer : !reviewerProfileFilterItem.isAIReviewer )).length % 3 > 0 && width >= 527 &&
          (reviewerProfiles.filter((reviewerProfileFilterItem => selectedReviewType.type === 'AI' ? reviewerProfileFilterItem.isAIReviewer : !reviewerProfileFilterItem.isAIReviewer )).length % 3 === 1 && width >= 790 ? [1, 2] : [1]).map( dummy => (
            dummyBoxWidth('250px', 0, dummy)
          ))
        }

      </Box>
    </Box>
  )
}